import { render, staticRenderFns } from "./DeviceSetupConfigurationFile.vue?vue&type=template&id=1809a12e&"
import script from "./DeviceSetupConfigurationFile.vue?vue&type=script&lang=js&"
export * from "./DeviceSetupConfigurationFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports